import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from '@/components/organisms/AppHeader';
import BrandLoading from '@/components/organisms/BrandLoading';
import EntryReady from '@/components/atoms/EntryReady';
import { features } from '@/lib/features';
import { useAuthStore } from '@/stores/useAuthStore';
import { usePageMotion } from '@/hooks/usePageMotion';

const MemberEventSubscriptions = lazy(
  () => import('@/realtime/MemberEventSubscriptions'),
);

/** 기본 화면의 헤더와 콘텐츠. 하단 메뉴는 RootLayout에서 유지한다. */
export default function AppShell() {
  const memberId = useAuthStore((state) => state.member?.id);
  const motion = usePageMotion();

  return (
    <>
      {features.realtime && memberId && (
        <Suspense fallback={null}>
          <MemberEventSubscriptions />
        </Suspense>
      )}
      <AppHeader />
      <main
        ref={motion}
        className="gp-motion-scene flex-1 pb-[var(--gp-bottom-nav-overhang,0px)]"
      >
        <Suspense fallback={<BrandLoading />}>
          <Outlet />
          <EntryReady />
        </Suspense>
      </main>
    </>
  );
}
